import { call, put } from 'redux-saga/effects'
import { toast } from 'react-toastify'
import { getUserBalance, getUserPoints } from '../requests/rewardService'
import {
  setCustomerBalance,
  setCustomerTransactions,
  setLoading,
  setError,
} from '../../slices/rewardLoyaltySlice'

function getErrorMessage(e) {
  try {
    const msg = e.response?.data?.message || e.response?.data?.error || e.message
    return typeof msg === 'string' ? msg : String(msg)
  } catch {
    return 'An unexpected error occurred'
  }
}

export function* handleFetchCustomerBalance(action) {
  try {
    yield put(setLoading(true))
    const { data } = yield call(getUserBalance, action.payload)
    yield put(setCustomerBalance(data))
  } catch (e) {
    const errorMsg = getErrorMessage(e)
    yield put(setError(errorMsg))
    toast.error(errorMsg)
  }
}

export function* handleFetchCustomerTransactions(action) {
  try {
    yield put(setLoading(true))
    const { customerId, params } = action.payload
    const { data } = yield call(getUserPoints, customerId, params)
    const transactions = Array.isArray(data) ? data : (data.items || [])
    yield put(setCustomerTransactions({
      data: transactions,
      total: transactions.length,
    }))
  } catch (e) {
    const errorMsg = getErrorMessage(e)
    yield put(setError(errorMsg))
    toast.error(errorMsg)
  }
}
